import { notNullish } from '@paragon/utilities';

import { SceneObjectBounds } from './types';

export function mergeBounds(a: SceneObjectBounds, b: SceneObjectBounds): SceneObjectBounds {
  const minX = Math.min(a.position.x - a.size.width / 2, b.position.x - b.size.width / 2);
  const maxX = Math.max(a.position.x + a.size.width / 2, b.position.x + b.size.width / 2);
  const minY = Math.min(a.position.y - a.size.height / 2, b.position.y - b.size.height / 2);
  const maxY = Math.max(a.position.y + a.size.height / 2, b.position.y + b.size.height / 2);

  const result: SceneObjectBounds = {
    position: { x: (minX + maxX) / 2, y: (minY + maxY) / 2 },
    size: { width: maxX - minX, height: maxY - minY },
  };

  const desiredHeights = [a.desiredHeight, b.desiredHeight].filter(notNullish);
  if (desiredHeights.length > 0) {
    result.desiredHeight = Math.max(...desiredHeights);
  }

  return result;
}
